import * as moment from 'moment';

export const MAX_WAIT_TIME_IN_MS = 30000;
export const TMP_MAX_WAIT_TIME_IN_MS = 10000;
export const TIMER_INDICATOR = 'TIMESUP';
//@todo verify label block and pause duration
export const IS_PLANNED_PAUSE = block => block.label == 'Pause';
export const IS_PLANNED = block => block.type == 'PLANNED';
export const IS_REALISE = block => block.source != 'SYSTEM' && !IS_PLANNED(block);
export const IS_REALISE_NON_DECLARATIVE = block => block.source != 'SYSTEM' && !IS_PLANNED(block) && block.source != "DECLARATIVE";
export const PLANNED_PAUSE_DURATION = block => moment(block.end).diff(block.start, 'seconds');
export const IS_REALISE_PAUSE = block => block.label == 'PAUSE';
export const REALISE_PAUSE_DURATION = block => block.duration;
export const $DURATION = b => b.duration;
export const MAURICE_MATRICULE_TEST = ['R00785'];
export const MAX_DEPASSMENT = 7200;
export const TRAVAIL_NON_PLANIFIE_CODES = ['TRAVAILNONPLANIFIE', 'TRAVAILNONPLANIFIEHP'];
export const TRAVAIL_NON_PLANIFIE_HORS_PROD = 'TRAVAILNONPLANIFIEHP';
export const TRAVAIL_NON_PLANIFIE_PROD = 'TRAVAILNONPLANIFIE';
export const PORTUGAL_CODE = 'PT';
export const IS_PORTUGAL = 'IS_PORTUGAL';
export const DATE_DEBUT_FICHE_LABEL = 'dateDebutFiche';
export const DATE_FIN_FICHE_LABEL = 'dateFinFiche';
export const DATE_DEBUT_DEMANDE_LABEL = 'dateDebutDemande';
export const DATE_FIN_DEMANDE_LABEL = 'dateFinDemande';
export const DATE_FICHE_LABEL = 'dateFiche';
export const DATE_DEMANDE_LABEL = 'dateDemande';
export const CODE_LANG="code_lang";


// WEBPACK FOOTER //
// ./src/app/helpers/GlobalConstants.ts